<template>
  <router-view />
</template>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Space Grotesk', 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: #000510;
  color: #e8f0ff;
  overflow-x: hidden;
}

#app {
  min-height: 100vh;
  background: linear-gradient(180deg, #000510 0%, #0a0f1e 25%, #050a18 50%, #0a0f1e 75%, #000510 100%);
}

/* 霓虹风格滚动条 */
::-webkit-scrollbar {
  width: 12px;
  height: 12px;
}

::-webkit-scrollbar-track {
  background: rgba(5, 10, 25, 0.8);
  border-radius: 6px;
}

::-webkit-scrollbar-thumb {
  background: linear-gradient(180deg, #00f5ff 0%, #ba94f8 100%);
  border-radius: 6px;
  border: 2px solid rgba(5, 10, 25, 0.8);
  transition: all 0.3s ease;
  box-shadow: 0 0 10px rgba(0, 245, 255, 0.3);
}

::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(180deg, #00f5ff 0%, #ff00ff 100%);
  box-shadow: 0 0 15px rgba(0, 245, 255, 0.6), 0 0 30px rgba(255, 0, 255, 0.3);
}

/* 霓虹选中文本样式 */
::selection {
  background: rgba(0, 245, 255, 0.25);
  color: #fff;
  text-shadow: 0 0 8px rgba(0, 245, 255, 0.5);
}

::-moz-selection {
  background: rgba(0, 245, 255, 0.25);
  color: #fff;
  text-shadow: 0 0 8px rgba(0, 245, 255, 0.5);
}

/* 平滑滚动 */
html {
  scroll-behavior: smooth;
}

/* 链接默认样式 */
a {
  color: #00f5ff;
  text-decoration: none;
  transition: all 0.3s ease;
}

a:hover {
  color: #ba94f8;
  text-shadow: 0 0 8px rgba(0, 245, 255, 0.5);
}
</style>

